/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';

    /*
     Creates an product card image instance
     */
    angular
        .module('enervee_utils.product_card')
        .directive('productCardCheckoutPrice', productCardCheckoutPriceDirective);

    function productCardCheckoutPriceDirective() {
        return {
            restrict: 'E',
            // this is needed to fix spacing issues
            replace: true,
            scope: {
                product: '=',
                totalRebates: '@'
            },
            bindToController: true,
            controller: productCardCheckoutPriceController,
            controllerAs: 'vm',
            template: require('@app/shared/productCard/checkoutPrice/checkoutPriceView.html')
        };
    }

    productCardCheckoutPriceController.$inject = ['$scope', '$filter', '$timeout'];
    function productCardCheckoutPriceController($scope, $filter, $timeout) {
        this.$onInit = () => {
            const vm = this;
            vm.checkoutCmsContext = {};

            $scope.$watch(() => vm.totalRebates, function () {
                const checkoutInfo = vm.product.checkoutInfo;
                if (checkoutInfo) {
                    let discountedPrice = checkoutInfo.price -
                        (vm.totalRebates ? vm.totalRebates :
                            checkoutInfo.total_additional_discounts);
                    updateDiscountedPrice(discountedPrice);
                }
            })

            /**
             * Updates the discounted price sentence based on the given discountedPrice parameter and cms content
             *
             * @param discountedPrice
             */
            function updateDiscountedPrice(discountedPrice) {
                vm.checkoutCmsContext = {
                    'price': $filter('toCurrency')(discountedPrice)
                };
            }
        }
    }
})(angular);